import(/* webpackMode: "eager", webpackExports: ["InfoDocumentClient"] */ "/home/nexts/lm-master-front/src/flat-pages/info/info-document-client.tsx");
;
import(/* webpackMode: "eager" */ "/home/nexts/lm-master-front/src/flat-pages/info/info-page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["InfoSectionMenuClient"] */ "/home/nexts/lm-master-front/src/flat-pages/info/info-section-menu-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InfoTopNavigationClient"] */ "/home/nexts/lm-master-front/src/flat-pages/info/info-top-navigation-client.tsx");
